"use strict";
/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTabsElements = void 0;
function createElementFromHTML(input) {
    const template = document.createElement('template');
    template.innerHTML = input.trim();
    return template.content.firstChild;
}
function generateId() {
    return Math.random().toString(36).substring(2);
}
function prepareTabsElements(rootElement) {
    Array.from(rootElement.querySelectorAll('.tabs')).forEach((element) => {
        const idSequence = [];
        const getNextId = () => {
            const id = generateId();
            idSequence.push(id);
            return id;
        };
        const titleElements = Array.from(element.querySelectorAll('.tab__title'));
        const titles = titleElements.map((e) => e.innerHTML);
        let titlesHtml = '<div class="tabs__titles">';
        for (let i = 0; i < titles.length; i++) {
            titlesHtml += `<div class="tabs__title${i === 0 ? ' tabs__title_active' : ''}" data-tab-id="${getNextId()}">${titles[i]}</div>`;
        }
        titlesHtml += '</div>';
        const titlesBlock = createElementFromHTML(titlesHtml);
        element.prepend(titlesBlock);
        titleElements.map((e) => e.remove());
        Array.from(element.querySelectorAll('.tab')).forEach((tabElement, i) => {
            tabElement.dataset.tabContentId = idSequence[i];
            if (i === 0) {
                tabElement.classList.add('tab_active');
            }
        });
    });
}
exports.prepareTabsElements = prepareTabsElements;
let eventHandlerInited = false;
function initTabs(element) {
    prepareTabsElements(element);
    if (eventHandlerInited) {
        return;
    }
    eventHandlerInited = true;
    element.addEventListener('click', (event) => {
        const target = event.target;
        if (target && Array.from(target.classList).includes('tabs__title')) {
            const tabsRoot = target.parentElement.parentElement;
            const tabId = target.dataset.tabId;
            const oldActiveTab = tabsRoot.querySelector('.tabs__title_active');
            if (oldActiveTab) {
                const oldTabId = oldActiveTab.dataset.tabId;
                tabsRoot
                    .querySelector(`.tabs__title[data-tab-id="${oldTabId}"]`)
                    .classList.remove('tabs__title_active');
                tabsRoot.querySelector(`.tab[data-tab-content-id="${oldTabId}"]`).classList.remove('tab_active');
            }
            target.classList.add('tabs__title_active');
            tabsRoot.querySelector(`.tab[data-tab-content-id="${tabId}"]`).classList.add('tab_active');
        }
    });
}
exports.default = initTabs;
//# sourceMappingURL=tabs.js.map